import axiosInstance from "@/utils/axios";
import { handleAxiosError } from "@/utils/helpers/handle-axios-errors";
import type { AxiosResponse } from "axios";

export const checkAddress = async (
  params: CheckAddressParams
): Promise<AxiosResponse> => {
  try {
    const response = await axiosInstance.get("/api/auth/check-address", {
      params,
    });
    return response;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};

export const authLogin = async (payload: LoginProps): Promise<any> => {
  try {
    const response = await axiosInstance.post("/api/auth/login", payload);
    return response;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const updateUserProfile = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post("/api/user/profile", data);
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const updateProfile = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.patch("/api/user/profile", data,{
      headers:{
        'Content-Type':undefined  //axios will automatically decide the type 
      }
    });
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const getProfile = async (): Promise<any> => {
  try {
    const data = await axiosInstance.get("/api/user/profile");
    return data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const createUserProfile = async (
  profileData: Partial<User>,
  isProfileCreated: boolean = true
): Promise<any> => {
  try {
    const response = await axiosInstance.post("/api/user/create-profile", {
      ...profileData,
      isProfileCreated: isProfileCreated,
    });
    return response;
  } catch (error) {
    handleAxiosError(error);
  }
};
